import { render, staticRenderFns } from "./AiGenerator.vue?vue&type=template&id=5aa3ef05&scoped=true"
import script from "./AiGenerator.vue?vue&type=script&lang=js"
export * from "./AiGenerator.vue?vue&type=script&lang=js"
import style0 from "./AiGenerator.vue?vue&type=style&index=0&id=5aa3ef05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa3ef05",
  null
  
)

export default component.exports